// Mock data for Telephony AI landing page

export const featurePillars = [
  {
    id: 1,
    title: "Production-Ready Telephony",
    icon: "phone",
    color: "blue",
    features: [
      "Premium clean number provisioning",
      "Phone number selection & rotation",
      "Full inbound support",
      "Smart dialing engine",
      "Granular status codes",
      "High parallelism and low latency"
    ],
    description: "Built for AI-grade workloads"
  },
  {
    id: 2,
    title: "Compliance & Safety Built-In",
    icon: "shield-check",
    color: "purple",
    features: [
      "Automatic DND and blacklist enforcement",
      "Block access on violations",
      "Content and transcript moderation",
      "Number reputation protection",
      "India-aware infrastructure"
    ],
    description: "Ship without regulatory anxiety"
  },
  {
    id: 3,
    title: "Intelligent Call Orchestration",
    icon: "workflow",
    color: "indigo",
    features: [
      "Language picker at call start",
      "Voicemail detection",
      "Human escalation and call bridging",
      "Channel allocation",
      "Throttling and rate limits",
      "Workflow creation"
    ],
    description: "Design production-grade call flows"
  },
  {
    id: 4,
    title: "Deep Observability & Analytics",
    icon: "bar-chart-3",
    color: "cyan",
    features: [
      "Full CDR reporting",
      "Call analytics",
      "Audio recording access",
      "Real-time webhooks",
      "Performance visibility"
    ],
    description: "Measure and optimize engagement"
  },
  {
    id: 5,
    title: "Omnichannel Engagement Layer",
    icon: "layers",
    color: "teal",
    features: [
      "Voice + WhatsApp + Telegram + SMS",
      "Unified workflows",
      "Cross-channel automation",
      "Event-driven architecture"
    ],
    description: "Engage customers everywhere"
  },
  {
    id: 6,
    title: "Open, Pluggable AI Stack",
    icon: "plug",
    color: "violet",
    features: [
      "Bring your own agent",
      "Pluggable STT/TTS",
      "REST APIs",
      "Webhooks",
      "SDKs (Node/Python)"
    ],
    description: "Bring your own agent. We handle the rest."
  }
];

export const integrations = [
  { name: "LiveKit", logo: "radio" },
  { name: "Pipecat", logo: "pipe" },
  { name: "ElevenLabs", logo: "audio-lines" },
  { name: "Vapi", logo: "mic" }
];

export const painPoints = [
  {
    title: "Telephony Fragmentation",
    icon: "phone-off",
    points: [
      "Hard to get clean premium Indian numbers",
      "Number rotation is messy",
      "Inbound + outbound handled separately",
      "Omnichannel requires multiple vendors"
    ]
  },
  {
    title: "Compliance and Risk",
    icon: "alert-triangle",
    points: [
      "DND violations can break campaigns",
      "Blacklists and regulatory rules are complex",
      "Number reputation is fragile",
      "Safeguards are usually DIY"
    ]
  },
  {
    title: "AI Calling is Operationally Fragile",
    icon: "activity",
    points: [
      "Poor visibility into call outcomes",
      "Limited granular status codes",
      "Voicemail handling unreliable",
      "Language handling bolted on",
      "Human escalation expensive"
    ]
  },
  {
    title: "Scaling Breaks Things",
    icon: "trending-up",
    points: [
      "Parallel dialing hits limits",
      "Latency hurts real-time AI",
      "Manual throttling and rate limits",
      "Call quality degrades at volume"
    ]
  },
  {
    title: "Lack of Observability",
    icon: "eye-off",
    points: [
      "Messy CDR access",
      "Scattered recordings",
      "Weak analytics",
      "No transcript/content moderation"
    ]
  },
  {
    title: "Too Much Glue Code",
    icon: "git-branch",
    points: [
      "Stitching telephony providers",
      "Integrating dialer logic",
      "Adding compliance layers",
      "Building analytics from scratch",
      "Managing multiple vendor APIs"
    ]
  }
];

export const indiaAdvantages = [
  {
    title: "Indian DID Numbers",
    icon: "map-pin",
    description: "Premium Indian phone numbers with local presence"
  },
  {
    title: "TRAI-Aware Infrastructure",
    icon: "shield",
    description: "Built-in compliance with Indian telecom regulations"
  },
  {
    title: "DLT Support Ready",
    icon: "file-check",
    description: "Ready for DLT registration and compliance"
  },
  {
    title: "Local Call Quality",
    icon: "signal",
    description: "Optimized routing for superior Indian call quality"
  },
  {
    title: "Enterprise Grade",
    icon: "building-2",
    description: "Built for Indian enterprises with local support"
  }
];

export const codeExamples = {
  rest: `// Make an outbound call
const response = await fetch('https://api.telephonyai.dev/v1/calls', {
  method: 'POST',
  headers: {
    'Authorization': 'Bearer YOUR_API_KEY',
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    to: '+919876543210',
    from: '+919123456789',
    agent_id: 'your_agent_id',
    language: 'hi-IN',
    webhook_url: 'https://your-app.com/webhook'
  })
});

const call = await response.json();
console.log('Call initiated:', call.id);`,
  
  webhook: `// Handle call events
app.post('/webhook', (req, res) => {
  const { event, call_id, status, transcript } = req.body;
  
  switch(event) {
    case 'call.started':
      console.log('Call started:', call_id);
      break;
    case 'call.completed':
      console.log('Transcript:', transcript);
      // Process call outcome
      break;
    case 'call.requires_human':
      // Escalate to human agent
      escalateToHuman(call_id);
      break;
  }
  
  res.status(200).send('OK');
});`
};

// Mock form submission handlers
export const submitWaitlist = async (data) => {
  // Simulate API call
  console.log('Waitlist submission:', data);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Successfully joined waitlist!' });
    }, 1000);
  });
};

export const submitContact = async (data) => {
  // Simulate API call
  console.log('Contact form submission:', data);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};
